import React, { useEffect, useState } from 'react';
import { TONE_BADGE, TONE_BORDER, TONE_SURFACE, TONE_TEXT } from '../../utils/statusColors';
import { fmtDateTime } from '../../utils/formatters';
import { usersService } from '../../services/api';
import { aceiteDoAviso, autorDoAceite, avisosDoAceite } from '../../utils/empenho';
import { falhaIgnoradaDeProposito } from '../../design';

/**
 * A fatura APROVADA COM AVISO DE EMPENHO (o `empenhoAviso` do backend #468): o selo no cabeçalho da ficha e, no corpo,
 * a linha com os avisos aceitos, o motivo, quem aprovou e quando. O motivo mora na fatura para ser LIDO aqui: motivo
 * que ninguém lê é, na prática, aprovação sem motivo.
 */

function euLogado(): { id?: number; name?: string; role?: string } | null {
  try { return JSON.parse(localStorage.getItem('user') || 'null'); } catch { return null; }
}

export function SeloDoAceite({ inv }: { inv: any }) {
  const a = aceiteDoAviso(inv);
  if (!a) return null;
  return (
    <span
      data-selo-aceite-empenho
      className={`shrink-0 px-2.5 py-0.5 rounded-full text-xs font-medium ${TONE_BADGE.warning} cursor-help`}
      title={`Aprovada com motivo: ${a.nota}`}
    >
      ⚠ Aprovada com aviso de empenho
    </span>
  );
}

export function LinhaDoAceite({ inv }: { inv: any }) {
  const a = aceiteDoAviso(inv);
  const eu = euLogado();
  const [nomeLido, setNomeLido] = useState<string | null>(null);
  const userId = a?.userId ?? null;
  const precisaLer = userId != null && eu?.id !== userId && eu?.role === 'admin';

  useEffect(() => {
    setNomeLido(null);
    if (!precisaLer || userId == null) return;
    let vivo = true;
    // Só admin lê `GET /users/:id`; se falhar, fica "usuário #id", que é verdade.
    usersService.getById(userId).then((u: any) => { if (vivo && u?.name) setNomeLido(String(u.name)); })
      .catch(falhaIgnoradaDeProposito('o nome do autor é cortesia: sem ele a linha diz "usuário #id", que é verdade'));
    return () => { vivo = false; };
  }, [precisaLer, userId]);

  if (!a) return null;
  const avisos = avisosDoAceite(a);
  return (
    <div data-aceite-empenho role="note" className={`mb-4 p-3 rounded-lg border text-sm ${TONE_SURFACE.warning} ${TONE_BORDER.warning}`}>
      <div className={`font-medium ${TONE_TEXT.warning}`}>
        Aprovada com aviso de empenho{avisos ? `: ${avisos}` : ''}
      </div>
      <div className="mt-1 text-slate-200">
        Aprovada com motivo: <span data-motivo className="italic">“{a.nota}”</span>
      </div>
      <div data-autor className="mt-1 text-xs text-slate-400">
        Por {autorDoAceite(a, eu, nomeLido)}{a.at ? `, em ${fmtDateTime(a.at)}` : ''}
      </div>
    </div>
  );
}
